import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import config from '../config/config'
import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { setFlashMessage } from '../contexts/WebsiteContext'
import PageHeroTitle from '../components/PageHeroTitle'
import TeamMember from '../components/OurTeam/TeamMember'
import BottomImage from '../components/BottomImage'

const OurTeam = () => {
  const { t } = useTranslation()
  const pageName = 'OUR_TEAM'
  const [teamMembers, setTeamMembers] = useState([])

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axios.get(`${config.apiUrl}team-member`)
        setTeamMembers(response.data)
      } catch (error) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.error('Erreur lors du chargement GET team-member')
      }
    }

    fetchTeamMembers()
  }, [t])

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(pageName)}
        description={t(`${pageName}_DESCRIPTION`)}
      />

      <div className="p-3">
        {teamMembers.map((member) => (
          <TeamMember key={member.name} member={member} />
        ))}
      </div>

      <BottomImage name={pageName} />

      <Footer />
    </div>
  )
}

export default OurTeam
